import { render, staticRenderFns } from "./newTopic.vue?vue&type=template&id=6bd4eda1&scoped=true&"
import script from "./newTopic.vue?vue&type=script&lang=js&"
export * from "./newTopic.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/newTopic/editInterview.less?vue&type=style&index=0&id=6bd4eda1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd4eda1",
  null
  
)

component.options.__file = "newTopic.vue"
export default component.exports